import type { MaterialSymbolIcon } from '@gravitate-js/excalibrr'

import type { InvoiceStatus } from '../../../api/useFreight/types'

// Update the status configuration with proper typing and organization
export const invoiceStatusConfig: Partial<
  Record<
    InvoiceStatus,
    {
      icon: MaterialSymbolIcon
      title: string
      color: string
      tagProps: {
        success?: boolean
        warning?: boolean
        error?: boolean
        theme1?: boolean
        theme2?: boolean
      }
    }
  >
> = {
  cr_approval: {
    icon: 'currency_exchange',
    color: 'warning',
    title: 'CR Approval',
    tagProps: {
      warning: true,
    },
  },
  blocked: {
    icon: 'error',
    color: 'error',
    title: 'Blocked',
    tagProps: {
      error: true,
    },
  },
  failure: {
    icon: 'cancel',
    color: 'error',
    title: 'Failure',
    tagProps: {
      error: true,
    },
  },
  needs_attention: {
    icon: 'warning',
    color: 'warning',
    title: 'Needs Attention',
    tagProps: {
      warning: true,
    },
  },
  hold: {
    icon: 'pause_circle',
    color: 'warning',
    title: 'On Hold',
    tagProps: {
      warning: true,
    },
  },

  ready: {
    icon: 'check_circle',
    color: 'primary   ',
    title: 'Ready',
    tagProps: {
      theme2: true,
    },
  },
  sent: {
    icon: 'send',
    color: 'success',
    title: 'Sent',
    tagProps: {
      success: true,
    },
  },
  open: {
    icon: 'list',
    color: 'primary',
    title: 'Open',
    tagProps: {},
  },
}

// FreightInvoice interface
export interface FreightInvoice {
  id: string
  invoiceNumber: string
  updated: string
  updated_on: string
  updated_by: string
  created_date: string
  created_by: string
  invoiceStart: string
  invoiceDate: string
  timeToInvoice: string
  counterparty: string
  status: InvoiceStatus
  orderCount: number
  baseAmount: number
  accessorialAmount: number
  surchargeAmount: number
  totalAmount: number
  updatedBy: string
  updatedByName: string
}

// FreightInvoiceGroup interface
export interface FreightInvoiceGroup {
  id: string
  groupName: string
  updated: string
  updated_on: string
  updated_by: string
  created_date: string
  created_by: string
  counterparty: string
  status?: InvoiceStatus
  invoiceCount: number
  // Snake case properties for amounts
  base_amount: number
  accessorial_amount: number
  surcharge_amount: number
  total_amount: number
  updatedBy: string
  updatedByName: string
  invoices: string[]
  notes?: string
  prototype_status?: string
  cr_diff?: number
  associatedInvoices?: FreightInvoice[]
  invoice_count?: number
}
